import styled from 'styled-components';

import Button from 'components/Button';

export const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

export const ActionsList = styled.div`
  min-width: 172px;
  padding: 5px 0;
`;

export const ActionButton = styled(Button)`
  width: 100%;
  justify-content: flex-start;
`;

export const IconButton = styled(Button)`
  padding: 0;
`;
